import {useEffect, useState} from 'react'
import Loader from '../../custom/loader/Loader'
import {useAuth} from 'app/modules/auth/core/Auth'
import {Link, useLocation} from 'react-router-dom'
import {toAbsoluteUrl} from '_metronic/helpers'

const DashboardWrapper = () => {
  const {currentUser} = useAuth()
  const [loading, setLoading] = useState(true)
  const location = useLocation()
  useEffect(() => {
    if (currentUser?.systems) {
      setTimeout(() => {
        setLoading(false)
      }, 500)
    }
  }, [currentUser?.systems])

  useEffect(() => {
    if (location.pathname === '/dashboard') localStorage.removeItem('system_id')
  }, [location])

  return loading ? (
    <Loader />
  ) : (
    <div className='row g-4'>
      {currentUser?.systems.map((item: any, index: number) => (
        <div className='col-sm-12 col-md-6 col-lg-4' key={index}>
          <Link
            className='card-glass-wrapper text-decoration-none'
            to={item.route}
            onClick={() => localStorage.setItem('system_id', item.id)}
          >
            <div className='card-glass h-100 position-relative overflow-hidden'>
              <div className='position-absolute w-100 h-100 bg-glass-gradient'></div>
              <div className='card-glass-body position-relative p-4 d-flex flex-column'>
                <div className='mx-auto mb-3 p-3 bg-glass-icon rounded-3'>
                  <img
                    src={toAbsoluteUrl(item.icon)}
                    alt={item.name}
                    className='w-100 h-auto icon-3d'
                    style={{minHeight: '60px'}}
                  />
                </div>
                <h3 className='text-center text-white mb-3 px-3 py-2 bg-glass-text rounded-pill'>
                  {item.name}
                </h3>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  )
}

export {DashboardWrapper}
